import cn from 'clsx'
import { FC } from 'react'

import { Button } from '@/components/ui'

import TimeLeft from '@/assets/icons/time-left.svg'
import TimeNone from '@/assets/icons/time-none.svg'
import TimeTop from '@/assets/icons/time-top.svg'

interface ITimecodeToolbarProps {
	timecodePosition: string
	setTimecodePosition: (pos: 'left' | 'top' | 'none') => void
	isTranslateLoading?: boolean
}

const TimecodeToolbar: FC<ITimecodeToolbarProps> = ({
	timecodePosition,
	setTimecodePosition,
	isTranslateLoading
}) => {
	return (
		<div className='flex items-center justify-center gap-1 bg-gray-100 rounded-[4px] p-[2px]'>
			<Button
				disabled={isTranslateLoading}
				className={cn(
					'!p-[5px] !text-black !rounded-[4px]',
					timecodePosition === 'left'
						? 'bg-white'
						: 'bg-gray-100 hover:bg-gray-200'
				)}
				onClick={() => setTimecodePosition('left')}
			>
				<TimeLeft className='w-9 h-[14px]' />
			</Button>
			<Button
				disabled={isTranslateLoading}
				className={cn(
					'!pt-[8px] !px-[6.5px] !pb-1 !text-black rounded-[4px]',
					timecodePosition === 'top'
						? 'bg-white'
						: 'bg-gray-100 hover:bg-gray-200'
				)}
				onClick={() => setTimecodePosition('top')}
			>
				<TimeTop className='w-[31px] h-[12px]' />
			</Button>
			<Button
				disabled={isTranslateLoading}
				className={cn(
					'!py-[4px] !px-[6.5px] !text-black rounded-[4px]',
					timecodePosition === 'none'
						? 'bg-white'
						: 'bg-gray-100 hover:bg-gray-200'
				)}
				onClick={() => setTimecodePosition('none')}
			>
				<TimeNone className='w-[31px] h-[16px]' />
			</Button>
		</div>
	)
}

export default TimecodeToolbar
